import { Avatar, Col, Dropdown, MenuProps, Modal, Row, Space } from "antd";
import { ChevronIcon } from "../../assets";
import { UserOutlined } from "@ant-design/icons";
import { logout } from "../../redux/apiSlice/authSlice";
import { useAppDispatch } from "../../redux/hooks";
import { useNavigate } from "react-router-dom";
import useUser from "../../hooks/useUser";
import { useState } from "react";
import axiosClient from "../../api/axiosClient";
import { Loading } from "../../components";
import handleApiError from "../../utils/handleError";

export default function ProfileDropDown() {
  const dispatch = useAppDispatch();
  const { user } = useUser();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: "Profile",
      onClick: () => navigate("/profile"),
    },
    {
      key: "2",
      label: "Logout",
      onClick: () => setOpen(true),
    },
  ];

  async function handleLogout() {
    setLoading(false);
    setOpen(false);
    try {
      await axiosClient.get("logout");
      dispatch(logout());
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading ? <Loading /> : null}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => handleLogout()}
      >
        <Row justify="center" align="middle" style={{ textAlign: "center" }}>
          <Col span={24}>
            <h2>Logout</h2>
          </Col>
          <Col span={24}>
            <h3 style={{ fontWeight: 400 }}>
              Are you sure you want to logout?
            </h3>
          </Col>
        </Row>
      </Modal>
      <Dropdown menu={{ items }}>
        <Space size="middle" style={{ cursor: "pointer" }}>
          <p>{user?.username}</p>
          <Avatar size={45} icon={<UserOutlined />} />
          <ChevronIcon />
        </Space>
      </Dropdown>
    </>
  );
}
